import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Repositories from "../views/Repositories/Repositories.vue";
import Repo from "../views/Repositories/Repo.vue";
import CreateRepository from "../views/Repositories/CreateRepository.vue";
import Dashboard from "../views/Dashboard.vue";
import AddDataset from "@/views/Datasets/AddDataset.vue";
import AnnotateDataset from "@/views/Datasets/AnnotateDataset.vue";
import ConnectData from "@/views/Datasets/ConnectData.vue";
import Dataset from "@/views/Datasets/Dataset.vue";
import Canvas from "@/views/Canvas/Canvas.vue";
import CreateNarrative from "@/views/Narratives/CreateNarrative.vue";
import WatchNarrative from "@/views/Narratives/WatchNarrative.vue";
import Watch from "@/views/Narratives/Watch.vue";
import NewElement from "@/views/Narratives/NewElement.vue";
import EditElement from "@/views/Narratives/EditElement.vue";
import Narratives from "@/views/Narratives/Narratives.vue";
import Narrative from "@/views/Narratives/Narrative.vue";
import Playground from "@/views/Playground.vue";
import Viewer from "@/views/Narratives/Viewer.vue";
import { verifyAuthenticated } from "@/api.js";
import { authGuard } from '@/auth/AuthGuard.js'


Vue.use(VueRouter);
/*
const authGuard = (to, from, next) => {
  verifyAuthenticated()
    .then((res) => {
      return next();
    })
    .catch((res) => {
      return next("/sign-in");
    });
};
*/
const verifySignedOut = (to, from, next) => {
  verifyAuthenticated()
    .then((res) => {
      return next({
        name: "Dashboard",
        params: { username: res.data.email },
      });
    })
    .catch((res) => {
      return next();
    });
};

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/:username",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos",
    name: "Repos",
    component: Repositories,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/canvas",
    name: "Canvas",
    component: Canvas,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives/create",
    name: "CreateNarrative",
    component: CreateNarrative,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives/:narrativeName/elements/create",
    name: "NewElement",
    component: NewElement,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives/:narrativeName/elements/:elementId",
    name: "EditElement",
    component: EditElement,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives",
    name: "Narratives",
    component: Narratives,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives/:narrativeName",
    name: "Narrative",
    component: Narrative,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/narratives/:narrativeName/watch",
    name: "WatchNarrative",
    component: Viewer,
    // beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/create",
    name: "CreateRepository",
    component: CreateRepository,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/:name",
    name: "Repo",
    component: Repo,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/:repoName/add-dataset",
    name: "AddDataset",
    component: AddDataset,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/:repoName/:datasetName/connect-data",
    name: "ConnectData",
    component: ConnectData,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/:repoName/:datasetName/annotate-data",
    name: "AnnotateData",
    component: AnnotateDataset,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/repos/:repoName/:datasetName",
    name: "Dataset",
    component: Dataset,
    beforeEnter: authGuard,
    props: true,
  },

  {
    path: "/:username/playground",
    name: "Playground",
    component: Playground,
    beforeEnter: authGuard,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
  // linkActiveClass:
  //   'bg-gray-800 transition duration-150 ease-in-out router-link-exact-active',
});

export default router;
